export default "__VITE_ASSET__599ea3de__"